//import React from 'react';
import { Navigate } from 'react-router-dom';

function PrivateRoute({ children }) {
    const token = localStorage.getItem('token');
    const redirect = encodeURIComponent(window.location.pathname);
    return token ? children : <Navigate to ={`/auth?redirect=${redirect}`} />;
}
export default PrivateRoute;